import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectCommentsTransactions } from 'app/selectors/ugc/CommentsSelector';
import CommentsActions from 'app/actions/CommentsActions';
import ModalActions from 'app/actions/ModalActions';
import DeleteCommentModal from './DeleteCommentModal';

export class DeleteCommentModalContainer extends React.PureComponent {
  render() {
    return <DeleteCommentModal {...this.props} />;
  }
}

DeleteCommentModalContainer.propTypes = {
  // ownProps
  commentId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,

  // Redux props
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  commentsTransactions: selectCommentsTransactions(state)
});

const mapDispatchToProps = dispatch => ({
  commentsActions: bindActionCreators(CommentsActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCommentModalContainer);
